// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Implement drain product.
 * @author James Reid
 */

// @ts-check

// @@imports-module
import { Product } from "./Product.js"

// @@imports-types
import {
    ProductData,
    DRAIN_TYPES,
    PRODUCT_DISPLAY_CATEGORIES
} from "../types/index.js"

// @@body
class Drain extends Product {
    /**
     * Construct drain product from data returned from server.
     * @param {ProductData} data Product data returned from server.
     * @param {any} match Regexp match data for internal calculator sku code
     * pertaining to this extended class.
     */
    constructor(data, match) {
        super(data)

        // Parse regexp data.
        const { type } = /** @type {Object<string, string>} */ (match.groups)

        // Set extended class values.
        this.type = type === "HS" ? DRAIN_TYPES.horizontalSmall
            : type === "HL" ? DRAIN_TYPES.horizontalLarge
            : type === "HE" ? DRAIN_TYPES.horizontalExtender
            : type === "PS" ? DRAIN_TYPES.pipeSeal
            : type === "PB" ? DRAIN_TYPES.pipeBox
            : type === "IN" ? DRAIN_TYPES.internal
            : type === "TP" ? DRAIN_TYPES.top
            : DRAIN_TYPES.breather
        this.displayCategory = PRODUCT_DISPLAY_CATEGORIES.drain

        // Declare explicit [header, value] detail pairs for products requiring
        // specific named extra information in extras/essentials card quantity
        // selection table.
        this.tableDetail = this.code === "DIN_068_330_245" ? ["Diameter", "68mm"]
            : this.code === "DIN_100_330_245" ? ["Diameter", "100mm"]
            : this.code === "DIN_110_330_245" ? ["Diameter", "110mm"]
            : ["Name", this.name]
    }
}

// @@exports
export { Drain }
